import { login, logout, getProfile } from '@/api/admin/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: null,
  roles: [],
  permissions: []
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  }
}

const actions = {
  /**
   * 管理员登录
   * @param {Object} context
   * @param {Object} loginForm - { username, password }
   */
  async login({ commit }, loginForm) {
    const data = await login(loginForm)
    const token = data.token || data.access_token
    commit('SET_TOKEN', token)
    setToken(token)
    return data
  },

  /**
   * 获取当前用户信息
   */
  async getUserInfo({ commit }) {
    const data = await getProfile()
    commit('SET_USER_INFO', data)
    if (data.roles) {
      commit('SET_ROLES', data.roles.map(r => (typeof r === 'string' ? r : r.code)))
    }
    if (data.permissions) {
      commit('SET_PERMISSIONS', data.permissions)
    }
    return data
  },

  /**
   * 登出并重置状态
   */
  async logout({ commit }) {
    try {
      await logout()
    } catch (e) {
      // 即使接口失败也清除本地状态
    }
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
    commit('SET_ROLES', [])
    commit('SET_PERMISSIONS', [])
    removeToken()
  },

  /**
   * 重置 Token 状态
   */
  resetToken({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
    commit('SET_ROLES', [])
    commit('SET_PERMISSIONS', [])
    removeToken()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
